import './App.css';
import {
  Box,
  Item,
  Card,
  CardContent,
  FormControlLabel,
  TextField,
  Typography,
  Select,
  LinearProgress,
  Switch,
  MenuItem,
  FormControl,
  Button,
  InputLabel,
  ListSubheader,
  Divider,
  Grid,
  ListItemButton,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Slider,
  Dialog,
  DialogTitle,
  DialogContent
} from '@mui/material';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { v4 as uuidv4 } from 'uuid';
import { initializeApp } from 'firebase/app';
import { getDatabase, ref, set, update, onValue, push, query, orderByChild } from "firebase/database";
import useDebounce from './useDebounce';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DownloadIcon from '@mui/icons-material/Download';
import ShareIcon from '@mui/icons-material/Share';
import Description from '@mui/icons-material/Description';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Quote from './Quote';
import { useTranslation } from 'react-i18next';
import i18n from './18n'
import { useNavigate } from 'react-router';
import DateRangePicker from './components/DateRangePicker';

const firebaseConfig = {
    apiKey: "AIzaSyA8TopHMkPlDZRaKUv7bpaMnnYgfHDxMc4",
    authDomain: "lybra-pricing.firebaseapp.com",
    projectId: "lybra-pricing",
    storageBucket: "lybra-pricing.appspot.com",
    messagingSenderId: "127223574332",
    appId: "1:127223574332:web:4cea6a20e9c27603a4f839",
    measurementId: "G-NFK626DC0R",
    databaseURL: "https://lybra-pricing-default-rtdb.europe-west1.firebasedatabase.app/"
};

const countryBySpending = {
    'E': ['Argentina','Belize','Bolivia','Brazil','Chile','Colombia','Cuba','Ecuador','El Salvador','French Guiana (département of France)','Guadeloupe','Guatemala','Guyana','Haiti','Honduras','Martinique','Nicaragua','Panama','Paraguay','Peru','Puerto Rico','Saint-Barthélemy','Saint-Martin','Suriname','Uruguay','Venezuela'],
    'L': ['Czech Republic','Hungary','Poland','Romania','Serbia','Slovakia','Slovenia'],
    'M': ['Belgium','Gibraltar','Israel'],
    'H': ['Austria','Denmark','Finland','Germany','Iceland','Ireland','Liechtenstein','Luxembourg','Monaco','Netherlands','Norway','Qatar','Sweden','Switzerland','United Arab Emirates','United Kingdom','Australia','Hong Kong (China)','New Zealand (also part of Polynesia)','Singapore','Canada','United States of America']
}

const currencyMap = {
    'USD': {symbol:'$',multiplyer:1.2},
    'EUR': {symbol:'€',multiplyer:1}
}
  
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

function SimpleDialog(props) {
    const { onClose, selectedValue, open, data } = props;

    const handleClose = () => {
      onClose(selectedValue);
    };
  
    const handleListItemClick = (value) => {
      onClose(value);
    };
    
    const { t } = useTranslation()

    data.sort((a,b) => {
        return Date.parse(b.value.timestamp) - Date.parse(a.value.timestamp)
    })

    return (
      <Dialog onClose={handleClose} open={open} fullWidth={true} maxWidth={'sm'}>
        <DialogTitle sx={{ bgcolor: '#1c90bc', color: '#fff' }} textAlign={'center'}>
            {t('choose')}
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: '#fff',
                }}
                >
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <List sx={{ pt: 0, padding: '10px' }}>
          {data && data.map((dt) => (
              <ListItem button onClick={() => handleListItemClick(dt.id)} key={dt.id} divider={true}
              sx={{'&:hover, &:focus': { bgColor: '#dfdfdf' }}}>
                <ListItemText primary={dt.value.quote.name} secondary={dt.value.totals.annual.toFixed(0) + ' ' + currencyMap[dt.value.quote.currency ? dt.value.quote.currency:'EUR' ].symbol} sx={{width: '5rem'}}  />
                <ListItemText 
                    primary={new Date(Date.parse(dt.value.timestamp)).toLocaleDateString()}
                    primaryTypographyProps={{fontSize: '0.875rem', color :'rgba(0, 0, 0, 0.6)'}}
                    secondary={new Date(Date.parse(dt.value.timestamp)).toLocaleTimeString()} sx={{textAlign: 'right'}} />
                 <ListItemText 
                    sx={{width: '5rem', textAlign: 'right'}}
                    primary={dt.value.accepted ? 'Accepted '+dt.value.accepted.method : 'Not Accepted'}
                    primaryTypographyProps={{fontSize: '0.875rem', color :(dt.value.accepted ? 'rgb(32, 159, 63)':'rgba(0, 0, 0, 0.6)')}}
                    secondary={dt.value.accepted ? new Date(Date.parse(dt.value.accepted.timestamp)).toLocaleDateString() : ''} />
              </ListItem>
          ))}
        </List>
      </Dialog>
    );
  }
  
  SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired
  };

function PriceCalculator () {


    const { t } = useTranslation()

    const { loginWithRedirect, logout, isAuthenticated, user, isLoading, getAccessTokenSilently,  } = useAuth0()

    useEffect(() => {
        if (user) {
            const quotesRef = ref(database, 'users/' + user.sub)
            set(quotesRef, {
                name: user.name,
                email: user.email,
                picture: user.picture
            }) 
            setCurrentUser(user.sub)
        }
    }, [
        user
    ])

    const [open, setOpen] = useState(false);
    const [selectDeal, setSelectDeal] = useState(false)
    const [share, setShare] = useState(false);
    const [currentUser, setCurrentUser] = useState();
    const [accepted, setAccepted] = useState(false);
    const [selectedValue, setSelectedValue] = useState('');
    const [userList, setUserList] = useState([])
    const [userQuoteList, setUserQuoteList] = useState([]);

    const [deals, setDeals] = useState([])
    const [currentDealId, setCurrentDealId] = useState()
    const [acOwnerId, setAcOwnerId] = useState(null)

    const [searchDeal, setSearchDeal] = useState('')
    const [basic, setBasic] = useState('')
    const [priceConfigCode, setPriceConfigCode] = useState('')
    const [priceConfigs, setPriceConfigs] = useState(null)
    const [currency, setCurrency] = useState('EUR')
    const [forcedCurrency, setForcedCurrency] = useState(false)
    const [reseller, setReseller] = useState(null)
    const [resellerType, setResellerType] = useState(null)
    const [resellerCommission, setResellerCommission] = useState(null)
    const [resellerCountries, setResellerCountries] = useState([])
    const [resellerProducts, setResellerProducts] = useState([])
    const [resellerAcc, setResellerAcc] = useState(null)
    const [resellerPromos, setResellerPromos] = useState([])
    const [timestamp, setTimestamp] = useState('')

    const [expiration, setExpiration] = useState(14)

    const [expirationDate, setExpirationDate] = useState('')
    const [promos, setPromos] = useState([])
    const [countryPromos, setCountryPromos] = useState([])

    async function handleDealAssign (id) {
        const quoteListRef = ref(database, 'quotes/' + currentUser + '/' + quote.id)
        onValue(quoteListRef, async (snapshot) => {
            const quoteData = snapshot.val()
            if ((id === undefined || id === null) && quoteData.acDeal) return
            const response = await fetch('https://api.lybra.tech/API/pricing/ac/deal', {
                method: 'POST',
                headers: {
                    'Authorization': 'Basic ' + basic,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    quoteLink: currentUser ? 'https://pricing.lybra.tech/view/'+currentUser.substring(6)+'/'+quote.id:'',
                    acOwner: acOwnerId ? acOwnerId:null,
                    acDeal: id ? id : null,
                    reseller: reseller ? reseller:null,
                    resellerAcc: resellerAcc ? resellerAcc:null,
                    ...quoteData
                })
            })
            const data = await response.json()

            const quotesRef = ref(database, 'quotes/' + currentUser + '/' + quote.id)

            update(quotesRef, {
                acDeal: data.dealId
            })
            setCurrentDealId(data.dealId)
            setSelectDeal(false)
            setShare(true)
        }, {
            onlyOnce: true
        })
    }

    async function fetchDeals () {
        const reponse = await fetch('https://api.lybra.tech/API/pricing/ac/' + acOwnerId, {
            headers: {
                'Authorization': 'Basic ' + basic,
                'Content-Type': 'application/json'
            }
        })
        setDeals(await reponse.json())
        setSelectDeal(true)
    }

    const handleClickOpen = () => {
        setOpen(true);
      };
    
    const handleClose = (value) => {
        setOpen(false);
        setSelectedValue(value);
    };

    function getCurrentUserObject () {
        if (userList && userList.length > 0) {
            return userList.find(u => u.id === currentUser).value
        }
        return user
    }

    useEffect(() => {
        const configRef = ref(database, 'config')
        onValue(configRef, (data) => {
            const snap = data.val()
            if (snap && snap.basic) {
                setBasic(snap.basic)
            }
            if(snap && snap.currentPriceConfig){
                setPriceConfigCode(snap.currentPriceConfig)
            }
            if(snap && snap.priceConfigs && snap.priceConfigs){
                setPriceConfigs(snap.priceConfigs)
            }
            if(snap && snap.promo){
                setPromos(snap.promo)
            }
        }, {
            onlyOnce: true
        })
    }, [])

    useEffect(() => {
        if (user) {
            const previousId = localStorage.getItem('lb_last_quote_id_v2')
            if (previousId) {
                setSelectedValue(previousId)
            } else {
                initNewQuote()
            }
            
            if(user["https://user-prof.lybra.com/app_metadata"]) {

                if (user["https://user-prof.lybra.com/app_metadata"].acOwner) {
                    setAcOwnerId(user["https://user-prof.lybra.com/app_metadata"].acOwner)
                } else {
                    setAcOwnerId(null)
                }

                if (user["https://user-prof.lybra.com/app_metadata"].reseller) {
                    setReseller(user["https://user-prof.lybra.com/app_metadata"].reseller)
                    setResellerType(user["https://user-prof.lybra.com/app_metadata"].resellerType)
                    setResellerCommission(user["https://user-prof.lybra.com/app_metadata"].resellerCommission)
                    setResellerCountries(user["https://user-prof.lybra.com/app_metadata"].resellerCountries)
                    setResellerProducts(user["https://user-prof.lybra.com/app_metadata"].resellerProducts)
                    setResellerAcc(user["https://user-prof.lybra.com/app_metadata"].resellerAcc)
                    setResellerPromos(user["https://user-prof.lybra.com/app_metadata"].resellerPromos)
                } else {
                    setReseller(null)
                    setResellerType(null)
                    setResellerCommission(null)
                    setResellerCountries([])
                    setResellerProducts([])
                    setResellerAcc(null)
                    setResellerPromos([])
                }
                
                if (user["https://user-prof.lybra.com/app_metadata"].currency) {
                    setCurrency(user["https://user-prof.lybra.com/app_metadata"].currency)
                    setForcedCurrency(true)
                }else{
                    setForcedCurrency(false)
                }


                if (user["https://user-prof.lybra.com/app_metadata"].permissions
                && user["https://user-prof.lybra.com/app_metadata"].permissions.length > 0 ){
                    const userListRef = ref(database, 'users')
                    const usrList = []
                    onValue(userListRef, (snapshot) => {
                        snapshot.forEach((childSnapshot) => {
                            usrList.push({
                                id: childSnapshot.key,
                                value: childSnapshot.val()
                            })
                        });
                        setUserList(usrList)
                    }, {
                        onlyOnce: true
                    });
                }
            }
        }
    }, [ user ])

    useEffect(() => {
        if (user) {
            loadQuote()
        }
    }, [ selectedValue ])

    useEffect(() => {
        if(expiration && timestamp){
            setExpirationDate(expiringDate())
        }
    }, [ expiration, timestamp, i18n.language ])

    const [quote, setQuote] = useState({
        id: '',
        name: '',
        country: '',
        luxury: false,
        rooms: 10,
        adr: 200,
        roomTypes: 5,
        extraDiscount: 0,
        setupDiscount: 0,
        competitor: 7,
        seasonal: false,
        group: false,
        autopilot: false,
        displacement: false,
        gapAnalysis: false,
        commission: false,
        rateGrid: false,
        financial: false,
        bi: true,
        rms: true,
        eye: false,
        flights: false,
        rateChecker: false,
        restrictions: false,
        duration: 12,
        consultancy: false,
        product: '',
        channels: 1,
        hotels: 1,
        frequency: 2,
        los: 1,
        daysOut: 120,
        daysOutW: 365,
        dailyFrequency: 2,
        weeklyFrequency: 1,
        subQuotes: [],
        override: 0,
        overrideConfirmed: false,
        overrideConfirmedBy: '',
        priceConfigCode: undefined,
        currency: 'EUR',
        markup: 0,
        resellerCommission: 0,
        promo: '',
        properties: 1
    })

  const debouncedQuote = useDebounce(quote, 1000)

  function loadQuote(){
    if (selectedValue && currentUser) {
        const quoteRef = ref(database, 'quotes/' + currentUser + '/' + selectedValue)
        onValue(quoteRef, snapshot => {
            const value = snapshot.val()
            if (value !== undefined && value !== null && value.quote) {
                setQuote(value.quote)
                setCurrency(value.quote.currency)
                if(value.reseller){
                    setReseller(value.reseller)
                    setResellerCommission(value.resellerCommission)
                }
                if (value.acDeal) {
                    setCurrentDealId(value.acDeal)
                }
                if (value.accepted) {
                    setAccepted(value.accepted)
                } else {
                    setAccepted(null)
                }
                if(value.timestamp){
                    setTimestamp(value.timestamp)
                }
                if(value.expiration){
                    setExpiration(value.expiration)
                }
            } else {
                initNewQuote()
            }
        }, {
            onlyOnce: true
        })
    } else {
        initNewQuote()
    }
  }

  useEffect(() => {
    if(countryPromos && countryPromos.length > 0 && reseller && resellerPromos && resellerPromos.length > 0 && !countryPromos.every(cp => resellerPromos.includes(cp))){
        setCountryPromos(countryPromos.filter(cp => resellerPromos.includes(cp)))
    }
  }, [countryPromos])

  useEffect(() => {
    if(quote && quote.country && promos){
        setCountryPromos(Object.keys(promos).filter(p => !promos[p].countries || promos[p].countries.includes(quote.country)))
    }
}, [promos, quote.country])

  function setModulesByProduct(product,data){

    if(product === 'ASSISTANT'){
        return {
            ...data,
            product: product,
            bi:true,
            rms:true
            }
    }else if(product === 'ASSISTANT_LEI'){
        return {
            ...data,
            product: product,
            competitor : 7,
            roomTypes: 7,
            gapAnalysis : true,
            commission : true,
            bi:true,
            rms:true,
            autopilot:true,
            rateGrid:true,
            financial:true,
            rateChecker:true,
            hotels:8,
            channels:3,
            daysOut:120,
            daysOutW:365,
            los:2,
            dailyFrequency:2,
            weeklyFrequency:1
            }
    }else if(product === 'ASSISTANT_BUS'){
        return {
            ...data,
            product: product,
            competitor : 5,
            roomTypes: 5,
            gapAnalysis : true,
            commission : true,
            bi:true,
            rms:true,
            autopilot:true,
            rateGrid:true,
            financial:true,
            rateChecker:true,
            hotels:6,
            channels:3,
            daysOut:60,
            daysOutW:365,
            los:1,
            dailyFrequency:2,
            weeklyFrequency:1
            }
    }else if(product === 'ADVISOR'){
        return {
            ...data,
            product: product,
            competitor : 7,
            roomTypes: 7,
            displacement : false,
            gapAnalysis : false,
            commission : false,
            bi:false,
            rms:true,
            autopilot:false,
            rateGrid:true,
            financial:false,
            rateChecker:true,
            hotels:1,
            channels:5,
            daysOut:120,
            daysOutW:365,
            los:2,
            dailyFrequency:2,
            weeklyFrequency:1
            }
    }else{
        return {
            ...data,
            product: product
        }
    }
  }

  function initNewQuote () {
    const initialQuoteId = uuidv4()
    localStorage.setItem('lb_last_quote_id_v2', initialQuoteId)
    setCurrentDealId(undefined)
    setTimestamp(getDateString())
    setExpiration(14)
    setQuote({
        id: initialQuoteId,
        name: '',
        country: '',
        luxury: false,
        roomTypes: 5,
        extraDiscount: 0,
        setupDiscount: 0,
        competitor: 7,
        seasonal: false,
        rateChecker: false,
        group: false,
        duration: 12,
        autopilot: false,
        displacement: false,
        gapAnalysis: false,
        commission: false,
        rateGrid: false,
        financial: false,
        bi: true,
        rms: true,
        eye: false,
        flights: false,
        restrictions: false,
        consultancy: false,
        product: '',
        channels: 1,
        hotels: 1,
        frequency: 2,
        los: 1,
        daysOut: 120,
        daysOutW: 365,
        dailyFrequency: 2,
        weeklyFrequency: 1,
        priceConfigCode: undefined,
        currency: 'EUR',
        markup: 0,
        promo: '',
        properties: 1
    })
  }

  function getQuoteTotal (quote) {
    const quoteCopy = {
        ...quote,
        extraDiscount: parseInt(quote.extraDiscount),
        setupDiscount: parseInt(quote.setupDiscount),
        rooms: parseInt(quote.rooms),
        competitor: parseInt(quote.competitor),
        adr: parseFloat(quote.adr),
        roomTypes: parseInt(quote.roomTypes),
        channels: parseInt(quote.channels),
        hotels: parseInt(quote.hotels),
        los: parseInt(quote.los),
        frequency: parseInt(quote.frequency),
        daysOut: parseInt(quote.daysOut),
        daysOutW: parseInt(quote.daysOutW),
        dailyFrequency: parseInt(quote.dailyFrequency),
        weeklyFrequency: parseInt(quote.weeklyFrequency)
    }
  
    const quoteTotal = {
        month: 0,
        semester: 0,
        annual: 0,
        setup: 650,
        originMonth: 0,
        originAnnual: 0,
        originSemester: 0,
        originSetup: 0
      }
    
    let countrySpeding = 'S'
    Object.keys(countryBySpending).map(key => {
        if(countryBySpending[key].includes(quoteCopy.country)){
            countrySpeding = key
        }
    });
    
  
    let minPrice = 100
    let basePrice = 190
    let setupPrice = 800
    let countryMuliplyer = 1
    let priceConfig
    let currencyMultiplyer = currencyMap[currency].multiplyer
    
    if(quoteCopy.priceConfigCode){
        priceConfig = priceConfigs[quoteCopy.priceConfigCode]
    }else{
        quote.priceConfigCode = priceConfigCode
        priceConfig = priceConfigs[priceConfigCode]
    }
    
    if(countrySpeding !== 'S'){
        countryMuliplyer = priceConfig[countrySpeding]
    }
    
    basePrice = priceConfig.base
    setupPrice = priceConfig.setup

    if(quoteCopy.product === 'ASSISTANT_LEI' || quoteCopy.product === 'ASSISTANT_BUS'){
        quote.gapAnalysis = true
        quote.commission = true
        quote.bi=true
        quote.rms=true
        quote.autopilot=true
        quote.rateGrid=true
        quote.financial=true
        quote.rateChecker=true
        setupPrice += 50
    }

    if(quoteCopy.product === 'ASSISTANT_LEI'){
        quote.roomTypes = 7
        quote.competitor = 7
        basePrice = priceConfig.baseLei
        setupPrice = priceConfig.baseLeiSetup
        //Rate checker
        quote.hotels=8
        quote.channels=3
        quote.daysOut=120
        quote.daysOutW=365
        quote.los=2
        quote.dailyFrequency=2
        quote.weeklyFrequency=1
    }else if(quoteCopy.product === 'ASSISTANT_BUS'){
        quote.roomTypes = 5
        quote.competitor = 5
        quote.channels = 3
        quote.daysOut = 60
        quote.los = 1
        //Rate checker
        quote.hotels=6
        quote.channels=3
        quote.daysOut=60
        quote.daysOutW=365
        quote.los=1
        quote.dailyFrequency=2
        quote.weeklyFrequency=1

        basePrice = priceConfig.baseBus
        setupPrice = priceConfig.baseLeiSetup
    }else if(quoteCopy.product === 'ASSISTANT' || quoteCopy.product === 'ADVISOR'){
        if(quoteCopy.product === 'ADVISOR'){
            quote.roomTypes = 7
            quote.competitor = 7
            quote.rateGrid = true
            quote.rms = true
            quote.rateChecker = true
            quote.channels = 5
            quote.daysOut = 120
            quote.los = 2
            basePrice = priceConfig.baseAdv
            setupPrice = priceConfig.baseAdvSetup
            quote.group = false
            quote.luxury = false
        }else{
            quote.bi= true
            quote.rms= true
            if(quoteCopy.roomTypes > 5){
                basePrice += (quoteCopy.roomTypes-5)*10
                setupPrice += (quoteCopy.roomTypes-5)*5
            }
    
            if(quoteCopy.rateChecker){
                let totalReqDaily = quoteCopy.dailyFrequency*31*quoteCopy.daysOut
                let totalReqWeekly = quoteCopy.weeklyFrequency*4*quoteCopy.daysOutW
                let rateCheckerPrice = (totalReqDaily+totalReqWeekly)*quoteCopy.hotels*quoteCopy.channels*quoteCopy.los*0.0004
                if(rateCheckerPrice < 20){
                    rateCheckerPrice = 20
                }
    
                basePrice+=rateCheckerPrice
            }
        }

        if(quoteCopy.autopilot){
            basePrice+=20
        }
        

        if(quoteCopy.competitor > 7){
            basePrice += (quoteCopy.competitor-7)*10
            setupPrice += (quoteCopy.competitor-7)*10
        }
        
    }
    
    if(reseller){
        quote.reseller = reseller
        quoteCopy.reseller = reseller
        quoteCopy.consultancy = false
        if(resellerType === 'M'){
            quoteCopy.extraDiscount  = 0
            quote.extraDiscount  = 0
        }
        if(promos && quoteCopy.promo && promos[quoteCopy.promo].setupDiscount){
            quoteCopy.setupDiscount = promos[quoteCopy.promo].setupDiscount*100
            quote.setupDiscount = promos[quoteCopy.promo].setupDiscount*100
        }else{
            quoteCopy.setupDiscount = 0
            quote.setupDiscount = 0
        }
        quote.consultancy = false
    }

    if (quoteCopy.country === 'Italy' && quoteCopy.consultancy) {
        basePrice += 150
    }

    if(quoteCopy.flights){
        basePrice += 30 
    }

    if(quoteCopy.displacement){
        basePrice+=25
    }

    if(quoteCopy.eye){
        basePrice += 30 
    }

    if(quoteCopy.restrictions){
        basePrice+=20
    }

    quoteTotal.currency = currency
    quote.currency = currency

    quoteTotal.month = basePrice * countryMuliplyer * currencyMultiplyer
    quoteTotal.setup = setupPrice * countryMuliplyer * currencyMultiplyer
    quote.setup = quoteTotal.setup

    if(quoteCopy.group){
        quoteTotal.month = quoteTotal.month * 0.85
    }
    if(quoteCopy.luxury){
        quoteTotal.month = quoteTotal.month * 1.2
    }

    if (quoteCopy.extraDiscount !== 0 && (!reseller || (reseller && resellerType !== 'M'))) {
        quoteTotal.originMonth = quoteTotal.month
        quoteTotal.originSemester = (quoteTotal.month * 6) * 0.85
        quoteTotal.originAnnual = (quoteTotal.month * 12) * 0.75
    
        quoteTotal.month = quoteTotal.month * (1 - quoteCopy.extraDiscount / 100)
    }

    if (quoteCopy.setupDiscount > 0) {
        quoteTotal.originSetup = quoteTotal.setup
        quoteTotal.setup = quoteTotal.setup * (1 - quoteCopy.setupDiscount / 100)
    }

    if(reseller){
        quoteTotal.resellerPrice = quoteTotal.month
    }else{
        quoteTotal.resellerPrice = null
    }

    if(resellerType === 'M'){
        quoteTotal.month = quoteTotal.month * (1-resellerCommission)
        quoteTotal.month = quoteTotal.month*(1 + (quoteCopy.markup/100))
    }

    quoteTotal.semester = (quoteTotal.month * 6) * 0.85
    quoteTotal.annual = (quoteTotal.month * 12) * 0.75
    

    if(quote.override > 0 && quote.overrideConfirmed){
        quoteTotal.annual = quote.override
        quoteTotal.month = (quoteTotal.annual/0.75) / 12
        quoteTotal.semester = (quoteTotal.month * 6) * 0.85
    }

      return quoteTotal
  }

  function getDateString(){
    return new Date().toUTCString()+""
  }

  function expiringDate(){
    let dayMs= 86400000
    let dateMs = Date.parse(timestamp)
    let exp = dateMs + (dayMs*expiration)
    let lang = i18n.language === 'en' ? 'en-GB':(i18n.language+'-'+i18n.language.toUpperCase())
    
    return ""+new Date(exp).toLocaleDateString(lang,{ weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
  }

  function calculate () {
    const subQuotesWithTotal = quote.subQuotes ? quote.subQuotes.map(q => {
        return {
            ...q,
            totals: getQuoteTotal(q)
        }
    }) : []

    const mainQuoteTotals = getQuoteTotal(quote)
    
    const generalQuoteTotal = {...mainQuoteTotals}

    subQuotesWithTotal.forEach(subQuote => {
        generalQuoteTotal.month += Math.round(subQuote.totals.month)
        generalQuoteTotal.semester += Math.round(subQuote.totals.semester)
        generalQuoteTotal.annual += Math.round(subQuote.totals.annual)
        generalQuoteTotal.setup += Math.round(subQuote.totals.setup)
        generalQuoteTotal.originMonth += Math.round(subQuote.totals.originMonth)
        generalQuoteTotal.originAnnual += Math.round(subQuote.totals.originAnnual)
        generalQuoteTotal.originSemester += Math.round(subQuote.totals.originSemester)
        generalQuoteTotal.originSetup +=  Math.round(subQuote.totals.originSetup)
        if(subQuote.totals.resellerPrice){
            generalQuoteTotal.resellerPrice += Math.round(subQuote.totals.resellerPrice)
        }
    })

    setTotals({
        ...generalQuoteTotal,
        subTotals: [
            mainQuoteTotals,
            ...subQuotesWithTotal.map(q => q.totals)
        ]
    })

    if (user && quote.name && quote.id && !accepted) {
        const quotesRef = ref(database, 'quotes/' + currentUser + '/' + quote.id)
        set(quotesRef, {
            quote: {
                ...quote,
                totals: mainQuoteTotals,
                subQuotes: subQuotesWithTotal
            },
            acDeal: currentDealId ? currentDealId : null,
            totals: generalQuoteTotal,
            timestamp: timestamp ? timestamp: getDateString(),
            reseller: reseller ? reseller : null,
            resellerCommission: resellerCommission ? resellerCommission: 0,
            expiration: expiration ? expiration:14
        })
    }
  }

  const [totals, setTotals] = useState({
    month: 0,
    semester: 0,
    annual: 0,
    setup: 0,
    originMonth: 0,
    originSemester: 0,
    originAnnual: 0,
    originSetup: 0,
    subTotals: [],
    resellerPrice: 0
  })

  useEffect(() => {
    if (debouncedQuote && user && priceConfigCode && priceConfigs) {
        calculate()
    }
  }, [ user, debouncedQuote, priceConfigCode, priceConfigs, currency, expiration ])
  
  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
        loginWithRedirect()
    }
  }, [ isAuthenticated, isLoading ])

  const [pdfGenerated, setPdfGenerated] = useState(false)

  const navigate = useNavigate()


  useEffect(() => {
  })

  function renderQuote (callback, data, index, deletable) {
    return (
        <Fragment>
            <Card sx={{
                  borderRadius: '10px',
                  marginTop: '1rem'
              }}>
              <CardContent>
                  
                <Grid container spacing={4} style={{ alignItems: 'center'}}>
                    <Grid item xs={12} sm={10}>
                        <Typography variant="h5" style={{ color: '#3b7baf' }} component="div">
                            {t('heading')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2} style={{textAlign: 'right',  alignItems: 'center'}}>
                        {deletable && 
                            <Button 
                                variant="outlined" 
                                color="error"
                                style={{width: '100%'}}
                                disabled={isQuoteReadOnly(data)}
                                onClick={() => {
                                    if (window.confirm(t('removeConfirm', {name: quote.name}))) {
                                        setQuote({
                                            ...quote,
                                            subQuotes: quote.subQuotes.filter(s => s.name !== data.name)
                                        })
                                    }
                                }}>
                                    {t('remove')}
                            </Button>
                        }
                    </Grid>
                  </Grid>
                  
                  <Grid container spacing={4} style={{ marginTop: '0.5rem' }}>
                    <Grid item xs={12} sm={6}>
                        <Box xs={12} style={{border: '1px solid rgb(196, 196, 196)',borderRadius: '4px',padding: '0 25px',height: '54px',position: 'relative',display: 'flex',alignItems: 'center'}}>
                            <InputLabel style={{position: 'absolute',top: '0',left: '5px',marginTop: '-9px',fontSize: '12px',color: '#6b6b6b',backgroundColor: 'white',padding: '0 5px'}}>{t('expiration')}: {expiration}d ({expirationDate})</InputLabel>
                            <Slider
                                aria-label={t('expiration')}
                                defaultValue={14}
                                value={expiration}
                                min={7}
                                max={28}
                                step={7}
                                la
                                fullWidth
                                onChange={(e, value) => {
                                    setExpiration(value)
                                }}
                                disabled={isQuoteReadOnly(data)}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box xs={12} style={{border: '1px solid rgb(196, 196, 196)',borderRadius: '4px',padding: '0 25px',height: '54px',position: 'relative',display: 'flex',alignItems: 'center'}}>
                            <InputLabel style={{position: 'absolute',top: '0',left: '5px',marginTop: '-9px',fontSize: '12px',color: '#6b6b6b',backgroundColor: 'white',padding: '0 5px'}}>{t('rateChecker.properties')}: {data.properties}</InputLabel>
                            <Slider
                                aria-label={t('rateChecker.properties')}
                                defaultValue={1}
                                value={data.properties}
                                min={1}
                                max={100}
                                step={1}
                                la
                                fullWidth
                                onChange={(event) => {                              
                                    callback({
                                    ...data,
                                    properties: event.target.value
                                    })
                                }}
                                disabled={isQuoteReadOnly(data)}
                            />
                        </Box>
                    </Grid>
                  </Grid>

                  <Grid container spacing={4} style={{ marginTop: '0.5rem' }}>
                  <Grid item xs={12} sm={3}>
                      <TextField 
                      onChange={(event) => {
                          callback({
                          ...data,
                          name: event.target.value
                          })
                      }}
                      value={data.name}
                      fullWidth label={t('owner')}
                      disabled={isQuoteReadOnly(data)} />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                      <FormControl fullWidth>
                      <InputLabel id="country">
                          {t('country')}
                      </InputLabel>
                      <Select
                          labelId="country"
                          id="country"
                          fullWidth
                          value={data.country}
                          label={t('country')}
                          onChange={(event) => {                              
                              callback({
                              ...data,
                              country: event.target.value
                              })
                          }}
                          disabled={isQuoteReadOnly(data)}
                          >
                            {(!reseller || resellerCountries.indexOf('Albania') !== -1) && <MenuItem value={'Albania'}>Albania</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Algeria') !== -1) && <MenuItem value={'Algeria'}>Algeria</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Andorra') !== -1) && <MenuItem value={'Andorra'}>Andorra</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Angola') !== -1) && <MenuItem value={'Angola'}>Angola</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Austria') !== -1) && <MenuItem value={'Austria'}>Austria</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Bahrain') !== -1) && <MenuItem value={'Bahrain'}>Bahrain</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Belarus') !== -1) && <MenuItem value={'Belarus'}>Belarus</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Belgium') !== -1) && <MenuItem value={'Belgium'}>Belgium</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Benin') !== -1) && <MenuItem value={'Benin'}>Benin</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Bosnia and Herzegovina') !== -1) && <MenuItem value={'Bosnia and Herzegovina'}>Bosnia and Herzegovina</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Botswana') !== -1) && <MenuItem value={'Botswana'}>Botswana</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Bulgaria') !== -1) && <MenuItem value={'Bulgaria'}>Bulgaria</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Burkina Faso') !== -1) && <MenuItem value={'Burkina Faso'}>Burkina Faso</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Burundi') !== -1) && <MenuItem value={'Burundi'}>Burundi</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Cameroon') !== -1) && <MenuItem value={'Cameroon'}>Cameroon</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Cape Verde') !== -1) && <MenuItem value={'Cape Verde'}>Cape Verde</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Central African Republic') !== -1) && <MenuItem value={'Central African Republic'}>Central African Republic</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Chad') !== -1) && <MenuItem value={'Chad'}>Chad</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Comoros') !== -1) && <MenuItem value={'Comoros'}>Comoros</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Croatia') !== -1) && <MenuItem value={'Croatia'}>Croatia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Cyprus') !== -1) && <MenuItem value={'Cyprus'}>Cyprus</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Czech Republic') !== -1) && <MenuItem value={'Czech Republic'}>Czech Republic</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Democratic Republic of the Congo') !== -1) && <MenuItem value={'Democratic Republic of the Congo'}>Democratic Republic of the Congo</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Denmark') !== -1) && <MenuItem value={'Denmark'}>Denmark</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Djibouti') !== -1) && <MenuItem value={'Djibouti'}>Djibouti</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Egypt') !== -1) && <MenuItem value={'Egypt'}>Egypt</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Equatorial Guinea') !== -1) && <MenuItem value={'Equatorial Guinea'}>Equatorial Guinea</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Eritrea') !== -1) && <MenuItem value={'Eritrea'}>Eritrea</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Estonia') !== -1) && <MenuItem value={'Estonia'}>Estonia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Ethiopia') !== -1) && <MenuItem value={'Ethiopia'}>Ethiopia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Faroe Islands') !== -1) && <MenuItem value={'Faroe Islands'}>Faroe Islands</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Finland') !== -1) && <MenuItem value={'Finland'}>Finland</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('France') !== -1) && <MenuItem value={'France'}>France</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Gabon') !== -1) && <MenuItem value={'Gabon'}>Gabon</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Gambia') !== -1) && <MenuItem value={'Gambia'}>Gambia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Georgia') !== -1) && <MenuItem value={'Georgia'}>Georgia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Germany') !== -1) && <MenuItem value={'Germany'}>Germany</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Ghana') !== -1) && <MenuItem value={'Ghana'}>Ghana</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Gibraltar') !== -1) && <MenuItem value={'Gibraltar'}>Gibraltar</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Greece') !== -1) && <MenuItem value={'Greece'}>Greece</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Guernsey') !== -1) && <MenuItem value={'Guernsey'}>Guernsey</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Guinea') !== -1) && <MenuItem value={'Guinea'}>Guinea</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Guinea-Bissau') !== -1) && <MenuItem value={'Guinea-Bissau'}>Guinea-Bissau</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Hungary') !== -1) && <MenuItem value={'Hungary'}>Hungary</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Iceland') !== -1) && <MenuItem value={'Iceland'}>Iceland</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Iran') !== -1) && <MenuItem value={'Iran'}>Iran</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Iraq') !== -1) && <MenuItem value={'Iraq'}>Iraq</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Ireland') !== -1) && <MenuItem value={'Ireland'}>Ireland</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Isle Of Man') !== -1) && <MenuItem value={'Isle Of Man'}>Isle Of Man</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Israel') !== -1) && <MenuItem value={'Israel'}>Israel</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Italy') !== -1) && <MenuItem value={'Italy'}>Italy</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Ivory Coast') !== -1) && <MenuItem value={'Ivory Coast'}>Ivory Coast</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Jersey') !== -1) && <MenuItem value={'Jersey'}>Jersey</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Jordan') !== -1) && <MenuItem value={'Jordan'}>Jordan</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Kenya') !== -1) && <MenuItem value={'Kenya'}>Kenya</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Kuwait') !== -1) && <MenuItem value={'Kuwait'}>Kuwait</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Latvia') !== -1) && <MenuItem value={'Latvia'}>Latvia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Lebanon') !== -1) && <MenuItem value={'Lebanon'}>Lebanon</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Lesotho') !== -1) && <MenuItem value={'Lesotho'}>Lesotho</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Liberia') !== -1) && <MenuItem value={'Liberia'}>Liberia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Libya') !== -1) && <MenuItem value={'Libya'}>Libya</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Liechtenstein') !== -1) && <MenuItem value={'Liechtenstein'}>Liechtenstein</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Lithuania') !== -1) && <MenuItem value={'Lithuania'}>Lithuania</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Luxembourg') !== -1) && <MenuItem value={'Luxembourg'}>Luxembourg</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Macedonia') !== -1) && <MenuItem value={'Macedonia'}>Macedonia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Madagascar') !== -1) && <MenuItem value={'Madagascar'}>Madagascar</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Malawi') !== -1) && <MenuItem value={'Malawi'}>Malawi</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Mali') !== -1) && <MenuItem value={'Mali'}>Mali</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Malta') !== -1) && <MenuItem value={'Malta'}>Malta</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Mauritania') !== -1) && <MenuItem value={'Mauritania'}>Mauritania</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Mauritius') !== -1) && <MenuItem value={'Mauritius'}>Mauritius</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Moldova') !== -1) && <MenuItem value={'Moldova'}>Moldova</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Monaco') !== -1) && <MenuItem value={'Monaco'}>Monaco</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Montenegro') !== -1) && <MenuItem value={'Montenegro'}>Montenegro</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Morocco') !== -1) && <MenuItem value={'Morocco'}>Morocco</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Mozambique') !== -1) && <MenuItem value={'Mozambique'}>Mozambique</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Namibia') !== -1) && <MenuItem value={'Namibia'}>Namibia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Netherlands') !== -1) && <MenuItem value={'Netherlands'}>Netherlands</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Niger') !== -1) && <MenuItem value={'Niger'}>Niger</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Nigeria') !== -1) && <MenuItem value={'Nigeria'}>Nigeria</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Norway') !== -1) && <MenuItem value={'Norway'}>Norway</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Oman') !== -1) && <MenuItem value={'Oman'}>Oman</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Palestine') !== -1) && <MenuItem value={'Palestine'}>Palestine</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Poland') !== -1) && <MenuItem value={'Poland'}>Poland</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Portugal') !== -1) && <MenuItem value={'Portugal'}>Portugal</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Qatar') !== -1) && <MenuItem value={'Qatar'}>Qatar</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Romania') !== -1) && <MenuItem value={'Romania'}>Romania</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Rwanda') !== -1) && <MenuItem value={'Rwanda'}>Rwanda</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('San Marino') !== -1) && <MenuItem value={'San Marino'}>San Marino</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Sao Tome & Principe') !== -1) && <MenuItem value={'Sao Tome & Principe'}>Sao Tome &amp; Principe</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Saudi Arabia') !== -1) && <MenuItem value={'Saudi Arabia'}>Saudi Arabia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Senegal') !== -1) && <MenuItem value={'Senegal'}>Senegal</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Serbia') !== -1) && <MenuItem value={'Serbia'}>Serbia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Slovakia') !== -1) && <MenuItem value={'Slovakia'}>Slovakia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Slovenia') !== -1) && <MenuItem value={'Slovenia'}>Slovenia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Somalia') !== -1) && <MenuItem value={'Somalia'}>Somalia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('South Africa') !== -1) && <MenuItem value={'South Africa'}>South Africa</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Spain') !== -1) && <MenuItem value={'Spain'}>Spain</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Sudan') !== -1) && <MenuItem value={'Sudan'}>Sudan</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Swaziland') !== -1) && <MenuItem value={'Swaziland'}>Swaziland</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Sweden') !== -1) && <MenuItem value={'Sweden'}>Sweden</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Switzerland') !== -1) && <MenuItem value={'Switzerland'}>Switzerland</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Syria') !== -1) && <MenuItem value={'Syria'}>Syria</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Tanzania') !== -1) && <MenuItem value={'Tanzania'}>Tanzania</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Togo') !== -1) && <MenuItem value={'Togo'}>Togo</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Tunisia') !== -1) && <MenuItem value={'Tunisia'}>Tunisia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Turkey') !== -1) && <MenuItem value={'Turkey'}>Turkey</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Uganda') !== -1) && <MenuItem value={'Uganda'}>Uganda</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Ukraine') !== -1) && <MenuItem value={'Ukraine'}>Ukraine</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('United Arab Emirates') !== -1) && <MenuItem value={'United Arab Emirates'}>United Arab Emirates</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('United Kingdom') !== -1) && <MenuItem value={'United Kingdom'}>United Kingdom</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Vatican City') !== -1) && <MenuItem value={'Vatican City'}>Vatican City</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Western Sahara') !== -1) && <MenuItem value={'Western Sahara'}>Western Sahara</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Yemen') !== -1) && <MenuItem value={'Yemen'}>Yemen</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Zambia') !== -1) && <MenuItem value={'Zambia'}>Zambia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Zimbabwe') !== -1) && <MenuItem value={'Zimbabwe'}>Zimbabwe</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Argentina') !== -1) && <MenuItem value={'Argentina'}>Argentina</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Belize') !== -1) && <MenuItem value={'Belize'}>Belize</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Bolivia') !== -1) && <MenuItem value={'Bolivia'}>Bolivia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Brazil') !== -1) && <MenuItem value={'Brazil'}>Brazil</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Chile') !== -1) && <MenuItem value={'Chile'}>Chile</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Colombia') !== -1) && <MenuItem value={'Colombia'}>Colombia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Costa Rica') !== -1) && <MenuItem value={'Costa Rica'}>Costa Rica</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Cuba') !== -1) && <MenuItem value={'Cuba'}>Cuba</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Dominican Republic') !== -1) && <MenuItem value={'Dominican Republic'}>Dominican Republic</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Ecuador') !== -1) && <MenuItem value={'Ecuador'}>Ecuador</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('El Salvador') !== -1) && <MenuItem value={'El Salvador'}>El Salvador</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('French Guiana (département of France)') !== -1) && <MenuItem value={'French Guiana (département of France)'}>French Guiana (département of France)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Guadeloupe') !== -1) && <MenuItem value={'Guadeloupe'}>Guadeloupe</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Guatemala') !== -1) && <MenuItem value={'Guatemala'}>Guatemala</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Guyana') !== -1) && <MenuItem value={'Guyana'}>Guyana</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Haiti') !== -1) && <MenuItem value={'Haiti'}>Haiti</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Honduras') !== -1) && <MenuItem value={'Honduras'}>Honduras</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Martinique') !== -1) && <MenuItem value={'Martinique'}>Martinique</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Mexico') !== -1) && <MenuItem value={'Mexico'}>Mexico</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Nicaragua') !== -1) && <MenuItem value={'Nicaragua'}>Nicaragua</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Panama') !== -1) && <MenuItem value={'Panama'}>Panama</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Paraguay') !== -1) && <MenuItem value={'Paraguay'}>Paraguay</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Peru') !== -1) && <MenuItem value={'Peru'}>Peru</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Puerto Rico') !== -1) && <MenuItem value={'Puerto Rico'}>Puerto Rico</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Saint-Barthélemy') !== -1) && <MenuItem value={'Saint-Barthélemy'}>Saint-Barthélemy</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Saint-Martin') !== -1) && <MenuItem value={'Saint-Martin'}>Saint-Martin</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Suriname') !== -1) && <MenuItem value={'Suriname'}>Suriname</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Uruguay') !== -1) && <MenuItem value={'Uruguay'}>Uruguay</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Venezuela') !== -1) && <MenuItem value={'Venezuela'}>Venezuela</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Afghanistan') !== -1) && <MenuItem value={'Afghanistan'}>Afghanistan</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('American Samoa (United States)') !== -1) && <MenuItem value={'American Samoa (United States)'}>American Samoa (United States)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Ashmore and Cartier Islands') !== -1) && <MenuItem value={'Ashmore and Cartier Islands'}>Ashmore and Cartier Islands</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Australia') !== -1) && <MenuItem value={'Australia'}>Australia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Bangladesh') !== -1) && <MenuItem value={'Bangladesh'}>Bangladesh</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Bhutan') !== -1) && <MenuItem value={'Bhutan'}>Bhutan</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('British Indian Ocean Territory (United Kingdom)') !== -1) && <MenuItem value={'British Indian Ocean Territory (United Kingdom)'}>British Indian Ocean Territory (United Kingdom)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Brunei') !== -1) && <MenuItem value={'Brunei'}>Brunei</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Cambodia') !== -1) && <MenuItem value={'Cambodia'}>Cambodia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Chile Salas y Gómez Island (Chile)') !== -1) && <MenuItem value={'Chile Salas y Gómez Island (Chile)'}>Chile Salas y Gómez Island (Chile)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('China') !== -1) && <MenuItem value={'China'}>China</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Christmas Island (Australia)') !== -1) && <MenuItem value={'Christmas Island (Australia)'}>Christmas Island (Australia)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Cocos (Keeling) Islands (Australia)') !== -1) && <MenuItem value={'Cocos (Keeling) Islands (Australia)'}>Cocos (Keeling) Islands (Australia)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Cook Islands (New Zealand)') !== -1) && <MenuItem value={'Cook Islands (New Zealand)'}>Cook Islands (New Zealand)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Coral Sea Islands') !== -1) && <MenuItem value={'Coral Sea Islands'}>Coral Sea Islands</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Easter Island (Chile)') !== -1) && <MenuItem value={'Easter Island (Chile)'}>Easter Island (Chile)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Fiji') !== -1) && <MenuItem value={'Fiji'}>Fiji</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('French Polynesia (France)') !== -1) && <MenuItem value={'French Polynesia (France)'}>French Polynesia (France)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Guam (United States)') !== -1) && <MenuItem value={'Guam (United States)'}>Guam (United States)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Hawaii (United States)') !== -1) && <MenuItem value={'Hawaii (United States)'}>Hawaii (United States)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Heard Island and McDonald Islands') !== -1) && <MenuItem value={'Heard Island and McDonald Islands'}>Heard Island and McDonald Islands</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Hong Kong (China)') !== -1) && <MenuItem value={'Hong Kong (China)'}>Hong Kong (China)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('India') !== -1) && <MenuItem value={'India'}>India</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Indonesia (also part of Melanesia)') !== -1) && <MenuItem value={'Indonesia (also part of Melanesia)'}>Indonesia (also part of Melanesia)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Japan') !== -1) && <MenuItem value={'Japan'}>Japan</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Kiribati') !== -1) && <MenuItem value={'Kiribati'}>Kiribati</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Laos') !== -1) && <MenuItem value={'Laos'}>Laos</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Macau (China)') !== -1) && <MenuItem value={'Macau (China)'}>Macau (China)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Malaysia') !== -1) && <MenuItem value={'Malaysia'}>Malaysia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Maldives') !== -1) && <MenuItem value={'Maldives'}>Maldives</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Marshall Islands') !== -1) && <MenuItem value={'Marshall Islands'}>Marshall Islands</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Micronesia, Federated States of') !== -1) && <MenuItem value={'Micronesia, Federated States of'}>Micronesia, Federated States of</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Mongolia') !== -1) && <MenuItem value={'Mongolia'}>Mongolia</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Myanmar') !== -1) && <MenuItem value={'Myanmar'}>Myanmar</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Nauru') !== -1) && <MenuItem value={'Nauru'}>Nauru</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Nepal') !== -1) && <MenuItem value={'Nepal'}>Nepal</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('New Caledonia (France)') !== -1) && <MenuItem value={'New Caledonia (France)'}>New Caledonia (France)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('New Zealand (also part of Polynesia)') !== -1) && <MenuItem value={'New Zealand (also part of Polynesia)'}>New Zealand (also part of Polynesia)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Niue (New Zealand)') !== -1) && <MenuItem value={'Niue (New Zealand)'}>Niue (New Zealand)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Norfolk Island (Australia)') !== -1) && <MenuItem value={'Norfolk Island (Australia)'}>Norfolk Island (Australia)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('North Korea') !== -1) && <MenuItem value={'North Korea'}>North Korea</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Northern Mariana Islands (United States)') !== -1) && <MenuItem value={'Northern Mariana Islands (United States)'}>Northern Mariana Islands (United States)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Pakistan') !== -1) && <MenuItem value={'Pakistan'}>Pakistan</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Palau') !== -1) && <MenuItem value={'Palau'}>Palau</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Papua New Guinea') !== -1) && <MenuItem value={'Papua New Guinea'}>Papua New Guinea</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Philippines') !== -1) && <MenuItem value={'Philippines'}>Philippines</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Pitcairn Islands (United Kingdom)') !== -1) && <MenuItem value={'Pitcairn Islands (United Kingdom)'}>Pitcairn Islands (United Kingdom)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Russian Far East (Russia)') !== -1) && <MenuItem value={'Russian Far East (Russia)'}>Russian Far East (Russia)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Samoa') !== -1) && <MenuItem value={'Samoa'}>Samoa</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Singapore') !== -1) && <MenuItem value={'Singapore'}>Singapore</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Solomon Islands') !== -1) && <MenuItem value={'Solomon Islands'}>Solomon Islands</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('South Korea') !== -1) && <MenuItem value={'South Korea'}>South Korea</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Sri Lanka') !== -1) && <MenuItem value={'Sri Lanka'}>Sri Lanka</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Taiwan') !== -1) && <MenuItem value={'Taiwan'}>Taiwan</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Thailand') !== -1) && <MenuItem value={'Thailand'}>Thailand</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Timor-Leste') !== -1) && <MenuItem value={'Timor-Leste'}>Timor-Leste</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Tokelau (New Zealand)') !== -1) && <MenuItem value={'Tokelau (New Zealand)'}>Tokelau (New Zealand)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Tonga') !== -1) && <MenuItem value={'Tonga'}>Tonga</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Tuvalu') !== -1) && <MenuItem value={'Tuvalu'}>Tuvalu</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Vanuatu') !== -1) && <MenuItem value={'Vanuatu'}>Vanuatu</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Vietnam') !== -1) && <MenuItem value={'Vietnam'}>Vietnam</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Wake Island (United States)') !== -1) && <MenuItem value={'Wake Island (United States)'}>Wake Island (United States)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Wallis and Futuna (France)') !== -1) && <MenuItem value={'Wallis and Futuna (France)'}>Wallis and Futuna (France)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Western New Guinea (Indonesia)') !== -1) && <MenuItem value={'Western New Guinea (Indonesia)'}>Western New Guinea (Indonesia)</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('Canada') !== -1) && <MenuItem value={'Canada'}>Canada</MenuItem>}
                            {(!reseller || resellerCountries.indexOf('United States of America') !== -1) && <MenuItem value={'United States of America'}>United States of America</MenuItem>}
                          </Select>
                      </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                      <FormControl fullWidth>
                      <InputLabel id="product">{t('product')}</InputLabel>
                      <Select
                          labelId="product"
                          id="product"
                          fullWidth
                          value={data.product}
                          label={t('product')}
                          onChange={(event) => {
                              callback(
                                setModulesByProduct(event.target.value,data)
                                )
                          }}
                          disabled={isQuoteReadOnly(data)}
                          >
                          {(!reseller || resellerProducts.indexOf('ASSISTANT_LEI') !== -1) && <MenuItem value={'ASSISTANT_LEI'}>Assistant for Leisure</MenuItem>}
                          {(!reseller || resellerProducts.indexOf('ASSISTANT_BUS') !== -1) && <MenuItem value={'ASSISTANT_BUS'}>Assistant for Business</MenuItem>}
                          {(!reseller || resellerProducts.indexOf('ASSISTANT') !== -1) && <MenuItem value={'ASSISTANT'}>Assistant for You</MenuItem>}
                          {(!reseller || resellerProducts.indexOf('ADVISOR') !== -1) && <MenuItem value={'ADVISOR'}>Advisor</MenuItem>}
                          </Select>
                      </FormControl>
                  </Grid>
                  {
                      (index === 0) && 
                      <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                        <InputLabel id="duration">{t('duration')}</InputLabel>
                        <Select
                            labelId="duration"
                            id="duration"
                            fullWidth
                            value={data.duration}
                            label={t('duration')}
                            onChange={(event) => {
                                callback({
                                    ...data,
                                    duration: event.target.value,
                                    setupDiscount: 0
                                })
                            }}
                            disabled={isQuoteReadOnly(data)}
                            >
                            <MenuItem value={12}>12 {t('momths')}</MenuItem>
                            <MenuItem value={24}>24 {t('momths')}</MenuItem>
                            <MenuItem value={36}>36 {t('momths')}</MenuItem>
                            <MenuItem value={48}>48 {t('momths')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                  }
                  </Grid>

              </CardContent>
              </Card>

              <Card
              sx={{
                  borderRadius: '10px'
              }}
              style={{ marginTop: '2rem' }}
              hidden={!(data.name && data.product && data.country)}>
              <CardContent>
                  
                  <Typography variant="h5" style={{ color: '#3b7baf' }} component="div">
                      {t('configuration')}
                  </Typography>

                  <Grid container spacing={4} style={{ marginTop: '0.5rem' }}>
                  <Grid item xs={12} sm={6} >
                      <Box xs={12} style={{border: '1px solid rgb(196, 196, 196)',borderRadius: '4px',padding: '0 25px',height: '54px',position: 'relative',display: 'flex',alignItems: 'center'}}>
                      <InputLabel style={{position: 'absolute',top: '0',left: '5px',marginTop: '-9px',fontSize: '12px',color: '#6b6b6b',backgroundColor: 'white',padding: '0 5px'}}>{t('roomTypes')}: {data.roomTypes}</InputLabel>
                      <Slider
                          aria-label={t('ropomTypes')}
                          defaultValue={5}
                          value={data.roomTypes}
                          min={5}
                          max={15}
                          la
                          fullWidth
                          onChange={(e, value) => callback({
                              ...data,
                              roomTypes: value
                          })}
                          disabled={isQuoteReadOnly(data)}
                          />
                      </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                      <Box xs={12} style={{border: '1px solid rgb(196, 196, 196)',borderRadius: '4px',padding: '0 25px',height: '54px',position: 'relative',display: 'flex',alignItems: 'center'}}>
                      <InputLabel style={{position: 'absolute',top: '0',left: '5px',marginTop: '-9px',fontSize: '12px',color: '#6b6b6b',backgroundColor: 'white',padding: '0 5px'}}>{t('competitor')}: {data.competitor}</InputLabel>
                      <Slider
                          aria-label={t('competitor')}
                          defaultValue={7}
                          value={data.competitor}
                          valueLabelDisplay="auto"
                          step={1}
                          min={5}
                          max={20}
                          la
                          fullWidth
                          onChange={(e, value) => callback({
                              ...data,
                              competitor: value
                          })}
                          disabled={isQuoteReadOnly(data)}
                          />
                      </Box>
                  </Grid>
                  </Grid>

                  <List
                  style={{
                      marginTop: '1rem'
                  }}
                  sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                  hidden={data.product === 'ADVISOR'}>
                  <ListItem disableGutters>
                      <ListItemText id="switch-list-label-bluetooth" primary={t('group')} />
                      <Switch
                      edge="end"
                      onChange={e => {
                          callback({
                          ...data,
                          group: e.target.checked
                          })
                      }}
                      checked={data.group}
                      inputProps={{
                          'aria-labelledby': 'switch-list-label-bluetooth',
                      }}
                      disabled={isQuoteReadOnly(data)}
                      />
                  </ListItem>
                  <ListItem disableGutters>
                      <ListItemText id="switch-list-label-bluetooth" primary={t('lux')} />
                      <Switch
                      edge="end"
                      onChange={e => {
                          callback({
                          ...data,
                          luxury: e.target.checked
                          })
                      }}
                      checked={data.luxury}
                      inputProps={{
                          'aria-labelledby': 'switch-list-label-bluetooth',
                      }}
                      disabled={isQuoteReadOnly(data)}
                      />
                  </ListItem>
                  </List>
                      </CardContent>
                  </Card>
              


              <Card
              sx={{
                  borderRadius: '10px'
              }}
              style={{ marginTop: '2rem' }}
              hidden={!(data.name && data.product && data.country)}>
              <CardContent>
                  
                  <Typography variant="h5" style={{ color: '#3b7baf' }} component="div">
                  {t('modules.title')}
                  </Typography>

                  <List
                  style={{
                      marginTop: '1rem'
                  }}
                  sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                  <ListItem disableGutters>
                      <ListItemText id="switch-list-label-wifi" primary="Autopilot" />
                      <Switch
                      edge="end"
                      onChange={e => {
                          callback({
                          ...data,
                          autopilot: e.target.checked
                          })
                      }}
                      checked={data.autopilot}
                      inputProps={{
                          'aria-labelledby': 'switch-list-label-wifi',
                      }}
                      disabled={isQuoteReadOnly(data)}
                      />
                  </ListItem>
                  <ListItem disableGutters>
                      <ListItemText id="switch-list-label-wifi" primary="Rate Grid" />
                      <Switch
                      edge="end"
                      onChange={e => {
                          callback({
                          ...data,
                          rateGrid: e.target.checked
                          })
                      }}
                      checked={data.rateGrid}
                      inputProps={{
                          'aria-labelledby': 'switch-list-label-wifi',
                      }}
                      disabled={isQuoteReadOnly(data)}
                      />
                  </ListItem>
                  <ListItem disableGutters>
                      <ListItemText id="switch-list-label-wifi" primary="Financial Analysis + Budget" />
                      <Switch
                      edge="end"
                      onChange={e => {
                          callback({
                          ...data,
                          financial: e.target.checked
                          })
                      }}
                      checked={data.financial}
                      inputProps={{
                          'aria-labelledby': 'switch-list-label-wifi',
                      }}
                      disabled={data.product === 'ADVISOR' || isQuoteReadOnly(data)}
                      />
                  </ListItem>
                  <ListItem disableGutters>
                      <ListItemText id="switch-list-label-wifi" primary="BI Module" />
                      <Switch
                      edge="end"
                      onChange={e => {
                          callback({
                          ...data,
                          bi: e.target.checked
                          })
                      }}
                      checked={data.bi}
                      inputProps={{
                          'aria-labelledby': 'switch-list-label-wifi',
                      }}
                      disabled={data.product === 'ADVISOR' || isQuoteReadOnly(data)}
                      />
                  </ListItem>
                  <ListItem disableGutters>
                      <ListItemText id="switch-list-label-wifi" primary="RMS Module" />
                      <Switch
                      edge="end"
                      onChange={e => {
                          callback({
                          ...data,
                          rms: e.target.checked
                          })
                      }}
                      checked={data.rms}
                      inputProps={{
                          'aria-labelledby': 'switch-list-label-wifi',
                      }}
                      disabled={isQuoteReadOnly(data)}
                      />
                  </ListItem>
                  <ListItem disableGutters>
                      <ListItemText id="switch-list-label-wifi" primary="Group displacement" />
                      <Switch
                      edge="end"
                      onChange={e => {
                          callback({
                          ...data,
                          displacement: e.target.checked
                          })
                      }}
                      checked={data.displacement}
                      inputProps={{
                          'aria-labelledby': 'switch-list-label-wifi',
                      }}
                      disabled={data.product === 'ADVISOR' || isQuoteReadOnly(data)}
                      />
                  </ListItem>
                  <ListItem disableGutters>
                      <ListItemText id="switch-list-label-bluetooth" primary={t('commission')} />
                      <Switch
                      edge="end"
                      onChange={e => {
                          callback({
                          ...data,
                          commission: e.target.checked
                          })
                      }}
                      checked={data.commission}
                      disabled={data.product === 'ADVISOR' || isQuoteReadOnly(data)}
                      inputProps={{
                          'aria-labelledby': 'switch-list-label-bluetooth',
                      }}
                      />
                  </ListItem>
                  <ListItem disableGutters>
                      <ListItemText id="switch-list-label-wifi" primary="Gap Analysis" />
                      <Switch
                      edge="end"
                      onChange={e => {
                          callback({
                          ...data,
                          gapAnalysis: e.target.checked
                          })
                      }}
                      checked={data.gapAnalysis}
                      inputProps={{
                          'aria-labelledby': 'switch-list-label-wifi',
                      }}
                      disabled={data.product === 'ADVISOR' || isQuoteReadOnly(data)}
                      />
                  </ListItem>
                  <ListItem disableGutters>
                      <ListItemText id="switch-list-label-bluetooth" primary={t('flights')} />
                      <Switch
                      edge="end"
                      onChange={e => {
                          callback({
                          ...data,
                          flights: e.target.checked
                          })
                      }}
                      checked={data.flights}
                      inputProps={{
                          'aria-labelledby': 'switch-list-label-bluetooth',
                      }}
                      disabled={isQuoteReadOnly(data)}
                      />
                  </ListItem>
                  <div hidden={data.country.toUpperCase() !== 'ITALY'}>
                    <ListItem disableGutters>
                        <ListItemText id="switch-list-label-bluetooth" primary="Eye" />
                        <Switch
                        edge="end"
                        onChange={e => {
                            callback({
                            ...data,
                            eye: e.target.checked
                            })
                        }}
                        checked={data.eye}
                        inputProps={{
                            'aria-labelledby': 'switch-list-label-bluetooth',
                        }}
                        disabled={isQuoteReadOnly(data)}
                        />
                    </ListItem>
                  </div>
                  <ListItem disableGutters>
                      <ListItemText id="switch-list-label-bluetooth" primary="Restrictions" />
                      <Switch
                      edge="end"
                      onChange={e => {
                          callback({
                          ...data,
                          restrictions: e.target.checked
                          })
                      }}
                      checked={data.restrictions}
                      inputProps={{
                          'aria-labelledby': 'switch-list-label-bluetooth',
                      }}
                      disabled={isQuoteReadOnly(data)}
                      />
                  </ListItem>
                  <ListItem disableGutters>
                      <ListItemText id="switch-list-label-bluetooth" primary="Rate Checker" />
                      <Switch
                      edge="end"
                      onChange={e => {
                          callback({
                          ...data,
                          rateChecker: e.target.checked
                          })
                      }}
                      checked={data.rateChecker}
                      inputProps={{
                          'aria-labelledby': 'switch-list-label-bluetooth',
                      }}
                      disabled={isQuoteReadOnly(data)}
                      />
                  </ListItem>
                  </List>

              </CardContent>
              </Card>

              <Card
              sx={{
                  borderRadius: '10px'
              }}
              style={{ marginTop: '2rem' }} hidden={(!data.rateChecker) || !(data.name && data.product && data.country)}>
              <CardContent>
                  
                  <Typography variant="h5" style={{ color: '#3b7baf' }} component="div">
                  Rate Checker
                  </Typography>
                  <Grid container spacing={4} style={{ marginTop: '0.5rem' }}>
                    <Grid item xs={12} sm={4}>
                        <Box xs={12} style={{border: '1px solid rgb(196, 196, 196)',borderRadius: '4px',padding: '0 25px',height: '54px',position: 'relative',display: 'flex',alignItems: 'center'}}>
                            <InputLabel style={{position: 'absolute',top: '0',left: '5px',marginTop: '-9px',fontSize: '12px',color: '#6b6b6b',backgroundColor: 'white',padding: '0 5px'}}>
                               {t('rateChecker.properties')}: {data.hotels}
                            </InputLabel>
                            <Slider
                                aria-label="# of hotels"
                                defaultValue={2}
                                value={data.hotels}
                                valueLabelDisplay="auto"
                                step={1}
                                min={1}
                                max={20}
                                la
                                fullWidth
                                onChange={(e, value) => callback({
                                ...data,
                                hotels: value
                                })}
                                disabled={isQuoteReadOnly(data)}
                            />
                            </Box>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box xs={12} style={{border: '1px solid rgb(196, 196, 196)',borderRadius: '4px',padding: '0 25px',height: '54px',position: 'relative',display: 'flex',alignItems: 'center'}}>
                            <InputLabel style={{position: 'absolute',top: '0',left: '5px',marginTop: '-9px',fontSize: '12px',color: '#6b6b6b',backgroundColor: 'white',padding: '0 5px'}}>
                                {t('channels')}: {data.channels}
                            </InputLabel>
                            <Slider
                                aria-label="# of channels"
                                defaultValue={2}
                                value={data.channels}
                                valueLabelDisplay="auto"
                                step={1}
                                min={1}
                                max={20}
                                la
                                fullWidth
                                onChange={(e, value) => callback({
                                ...data,
                                channels: value
                                })}
                                disabled={isQuoteReadOnly(data)}
                            />
                            </Box>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Box xs={12} style={{border: '1px solid rgb(196, 196, 196)',borderRadius: '4px',padding: '0 25px',height: '54px',position: 'relative',display: 'flex',alignItems: 'center'}}>
                          <InputLabel style={{position: 'absolute',top: '0',left: '5px',marginTop: '-9px',fontSize: '12px',color: '#6b6b6b',backgroundColor: 'white',padding: '0 5px'}}>
                            LOS Types: {data.los}
                          </InputLabel>
                          <Slider
                              aria-label="LOS"
                              defaultValue={1}
                              value={data.los}
                              valueLabelDisplay="auto"
                              step={1}
                              min={1}
                              max={10}
                              la
                              fullWidth
                              onChange={(e, value) => callback({
                              ...data,
                              los: value
                              })}
                              disabled={isQuoteReadOnly(data)}
                          />
                          </Box>
                      </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box xs={12} style={{border: '1px solid rgb(196, 196, 196)',borderRadius: '4px',padding: '0 25px',height: '54px',position: 'relative',display: 'flex',alignItems: 'center'}}>
                                <InputLabel style={{ position: 'absolute', top: '0', left: '5px', marginTop: '-9px', fontSize: '12px', color: '#6b6b6b', backgroundColor: 'white', padding: '0 5px' }}>
                                {t('daysOut')}: {data.daysOut}
                                </InputLabel>
                          <Slider
                              aria-label="# of days to shop daily"
                              defaultValue={2}
                              value={data.daysOut}
                              valueLabelDisplay="auto"
                              step={1}
                              min={30}
                              max={120}
                              la
                              fullWidth
                              onChange={(e, value) => callback({
                              ...data,
                              daysOut: value
                              })}
                              disabled={isQuoteReadOnly(data)}
                          />
                          </Box>
                      </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box xs={12} style={{border: '1px solid rgb(196, 196, 196)',borderRadius: '4px',padding: '0 25px',height: '54px',position: 'relative',display: 'flex',alignItems: 'center'}}>
                          <InputLabel style={{position: 'absolute',top: '0',left: '5px',marginTop: '-9px',fontSize: '12px',color: '#6b6b6b',backgroundColor: 'white',padding: '0 5px'}}>
                          {t('dailyFreq')}: {data.dailyFrequency}
                          </InputLabel>
                          <Slider
                              aria-label="Daily shop frequency"
                              defaultValue={2}
                              value={data.dailyFrequency}
                              valueLabelDisplay="auto"
                              step={1}
                              min={1}
                              max={6}
                              la
                              fullWidth
                              onChange={(e, value) => callback({
                              ...data,
                              dailyFrequency: value
                              })}
                              disabled={isQuoteReadOnly(data)}
                          />
                          </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                      <Box xs={12} style={{border: '1px solid rgb(196, 196, 196)',borderRadius: '4px',padding: '0 25px',height: '54px',position: 'relative',display: 'flex',alignItems: 'center'}}>
                          <InputLabel style={{position: 'absolute',top: '0',left: '5px',marginTop: '-9px',fontSize: '12px',color: '#6b6b6b',backgroundColor: 'white',padding: '0 5px'}}>
                            {t('daysOutW')}: {data.daysOutW}
                          </InputLabel>
                          <Slider
                              aria-label="# of days to shop weekly"
                              defaultValue={2}
                              value={data.daysOutW}
                              valueLabelDisplay="auto"
                              step={1}
                              min={120}
                              max={365}
                              la
                              fullWidth
                              onChange={(e, value) => callback({
                              ...data,
                              daysOutW: value
                              })}
                              disabled={isQuoteReadOnly(data)}
                          />
                          </Box>
                      </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box xs={12} style={{border: '1px solid rgb(196, 196, 196)',borderRadius: '4px',padding: '0 25px',height: '54px',position: 'relative',display: 'flex',alignItems: 'center'}}>
                          <InputLabel style={{position: 'absolute',top: '0',left: '5px',marginTop: '-9px',fontSize: '12px',color: '#6b6b6b',backgroundColor: 'white',padding: '0 5px'}}>
                          {t('weeklyFreq')}: {data.weeklyFrequency}
                          </InputLabel>
                          <Slider
                              aria-label="Weekly shop frequency"
                              defaultValue={2}
                              value={data.weeklyFrequency}
                              valueLabelDisplay="auto"
                              step={1}
                              min={1}
                              max={6}
                              la
                              fullWidth
                              onChange={(e, value) => callback({
                              ...data,
                              weeklyFrequency: value
                              })}
                              disabled={isQuoteReadOnly(data)}
                          />
                          </Box>
                      </Grid>
                  </Grid>
              </CardContent>
              </Card>

              <Card
              sx={{
                  borderRadius: '10px'
              }}
              style={{ marginTop: '2rem' }} hidden={data.country.toUpperCase() !== 'ITALY' || !(data.name && data.product && data.country) || reseller}>
              <CardContent>
                  
                  <Typography style={{ color: '#3b7baf' }} variant="h5" component="div">
                  {t('consultancy')}
                  </Typography>

                  <List
                  style={{
                      marginTop: '1rem'
                  }}
                  sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                  <ListItem disableGutters>
                      <ListItemText id="switch-list-label-wifi" primary={t('hoursPack')} />
                      <Switch
                      edge="end"
                      onChange={e => {
                          callback({
                          ...data,
                          consultancy: e.target.checked
                          })
                      }}
                      checked={data.consultancy}
                      inputProps={{
                          'aria-labelledby': 'switch-list-label-wifi',
                      }}
                      disabled={isQuoteReadOnly(data)}
                      />
                  </ListItem>
                  </List>

              </CardContent>
              </Card>

              <Card
              sx={{
                  borderRadius: '10px'
              }}
              hidden={!(data.name && data.product && data.country) || (reseller && resellerType === 'M')}
              style={{ marginTop: '2rem' }}>
              <CardContent>
                  <Typography style={{ marginBottom: 20, color: '#3b7baf' }} variant="h5" component="div">
                  {t('extraDiscount')}
                  </Typography>

                  <Grid container spacing={4}>
                    <Grid item xs={12} sm={6}>
                        <Box xs={12} style={{border: '1px solid rgb(196, 196, 196)',borderRadius: '4px',padding: '0 25px',height: '54px',position: 'relative',display: 'flex',alignItems: 'center'}}>
                        <InputLabel style={{position: 'absolute',top: '0',left: '5px',marginTop: '-9px',fontSize: '12px',color: '#6b6b6b',backgroundColor: 'white',padding: '0 5px'}}>{t('extraDiscount')}: {data.extraDiscount}%</InputLabel>
                        <Slider
                            aria-label={t('days')}
                            defaultValue={0}
                            value={data.extraDiscount}
                            valueLabelDisplay="auto"
                            step={5}
                            marks
                            min={-100}
                            max={30}
                            la
                            fullWidth
                            onChange={(e, value) => callback({
                            ...data,
                            extraDiscount: value
                            })}
                            disabled={isQuoteReadOnly(data)}
                        />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box xs={12} style={{border: '1px solid rgb(196, 196, 196)',borderRadius: '4px',padding: '0 25px',height: '54px',position: 'relative',display: 'flex',alignItems: 'center'}}>
                        <InputLabel style={{position: 'absolute',top: '0',left: '5px',marginTop: '-9px',fontSize: '12px',color: '#6b6b6b',backgroundColor: 'white',padding: '0 5px'}}>{t('setupDiscount')}: {data.setupDiscount}% <strong>{(totals && totals.subTotals && totals.subTotals.length > index) ? totals.subTotals[index].setup.toFixed(0):0} {currencyMap[currency].symbol}</strong></InputLabel>
                        <Slider
                            aria-label={t('days')}
                            defaultValue={0}
                            value={getSetupDiscount(data)}
                            valueLabelDisplay="auto"
                            step={5}
                            marks
                            min={0}
                            max={20}
                            la
                            fullWidth
                            onChange={(e, value) => callback({
                            ...data,
                            setupDiscount: value
                            })}
                            disabled={isQuoteReadOnly(data) || reseller}
                        />
                        </Box>
                    </Grid>
                  </Grid>

                  {
                      (data.product !== 'ASSISTANT_BUS' && data.product !== 'ASSISTANT_LEI' && !reseller) &&
                      <Fragment>
                          <Typography style={{ marginTop: 20, marginBottom: 20, color: '#3b7baf' }} variant="h5" component="div">
                              {t('proposeOverride')}
                          </Typography>

                          <Grid container spacing={4} style={{alignItems:'center'}}>
                              <Grid item xs={12} sm={4}>
                                  <TextField
                                      onChange={e => callback({
                                          ...data,
                                          override: parseFloat(e.target.value)
                                      })}
                                      value={data.override ? data.override : 0}
                                      fullWidth label={t('annualOverride')}
                                      disabled={isQuoteReadOnly(data)} />
                              </Grid>
                              <Grid  item xs={12} sm={8}>
                                  {(userList && userList.length > 0 && data && !data.overrideConfirmed && data.override > 0) && <Button
                                      variant="contained"
                                      color="success"
                                      style={{width: '100%'}}
                                      onClick={() => {
                                          callback({
                                              ...data,
                                              overrideConfirmed: true,
                                              overrideConfirmedBy: user.name
                                          })
                                      }}>
                                      {t('accept')}
                                  </Button>
                                  }
                                  {
                                      (data && data.overrideConfirmed) && <Typography style={{color: '#3b7baf' }} variant="body1" component="div">
                                          {t('proposeOverrideAccepted', {name: data.overrideConfirmedBy})}
                                      </Typography>
                                  }
                              </Grid>
                          </Grid>
                      </Fragment>
                  }

              </CardContent>
              </Card>

              <Card
                sx={{
                        borderRadius: '10px'
                    }}
                    hidden={!(data.name && data.product && data.country) || (reseller && (!resellerPromos || (resellerPromos && resellerPromos.length === 0)))} 
                    style={{ marginTop: '2rem' }}>
                  <CardContent>
                    <Typography style={{ marginBottom: 20, color: '#3b7baf' }} variant="h5" component="div">
                        {t('promo.title')}
                    </Typography>
                    <Fragment>
                    <Grid container spacing={4} style={{alignItems:'center'}}>
                     <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                        <InputLabel id="promo">{t('promo.code')}</InputLabel>
                        <Select
                            labelId="promo"
                            id="promo"
                            fullWidth
                            value={data.promo}
                            
                            label={t('promo')}
                            onChange={(e) => {
                                callback({
                                    ...data,
                                    promo: e.target.value
                                })
                            }}
                            disabled={isQuoteReadOnly(data)}
                            >
                                <MenuItem value="">------</MenuItem>
                            {
                                countryPromos && countryPromos.map(cp => (
                                    <MenuItem value={cp}>{cp}</MenuItem>
                                ))
                            }
                            </Select>
                        </FormControl>
                     </Grid>
                     <Grid item xs={12} sm={9}>
                        { promos && data.promo && promos[data.promo].description}
                    </Grid>
                     </Grid>
                    </Fragment>
                  </CardContent>
              </Card>    

              <Card
              sx={{
                  borderRadius: '10px'
              }}
              hidden={!(data.name && data.product && data.country) || !reseller || resellerType !== 'M'} 
              style={{ marginTop: '2rem' }}>
              <CardContent>
                  
                  <Typography style={{ marginBottom: 20, color: '#3b7baf' }} variant="h5" component="div">
                  Markup
                  </Typography>

                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={6}>
                            <Box xs={12} style={{border: '1px solid rgb(196, 196, 196)',borderRadius: '4px',padding: '0 25px',height: '54px',position: 'relative',display: 'flex',alignItems: 'center'}}>
                            <InputLabel style={{position: 'absolute',top: '0',left: '5px',marginTop: '-9px',fontSize: '12px',color: '#6b6b6b',backgroundColor: 'white',padding: '0 5px'}}>Markup: {data.markup}%</InputLabel>
                            <Slider
                                aria-label={t('days')}
                                defaultValue={0}
                                value={data.markup}
                                valueLabelDisplay="auto"
                                step={5}
                                marks
                                min={0}
                                max={100}
                                la
                                fullWidth
                                onChange={(e, value) => callback({
                                ...data,
                                markup: value
                                })}
                                disabled={isQuoteReadOnly(data)}
                            />
                            </Box>
                        </Grid>
                    </Grid>
                    </CardContent>
                </Card>

              {
                  (quote && quote.subQuotes && quote.subQuotes.length > 0) &&
                  <div style={{
                    width: '100%',
                    background: '#1c90bc',
                    paddingTop: (reseller && resellerType && resellerType === 'M') ? '.5rem':'1rem',
                    borderRadius: 10,
                    marginTop: '1rem',
                    paddingBottom: '1rem',
                    height: (reseller && resellerType && resellerType === 'M') ? '60px':'50px',
                    color: '#FFF'
                }}>
                    <Grid container spacing={0}>
                        <Grid item xs={4} style={{ textAlign: 'center' }}>
                            {t('monthly')}
                            <Typography variant="h5" style={{ color: '#FFF' }} component="div">
                            {
                                    (reseller && totals.resellerPrice && resellerType === 'M') && (totals.subTotals && totals.subTotals.length > index) &&
                                    <div style={{
                                        textAlign: 'center',
                                        fontSize: 16,
                                        textDecoration: 'line-through'
                                    }}>
                                        {totals.subTotals[index].resellerPrice.toFixed(0)} {currencyMap[quote.currency].symbol}
                                    </div>
                                }
                            {(totals.subTotals && totals.subTotals.length > index) ? totals.subTotals[index].month.toFixed(0) : 0} {currencyMap[currency].symbol}
                            </Typography>
                        </Grid>
                        <Grid item xs={4} style={{ textAlign: 'center', borderLeft: '1px solid rgba(255,255,255,0.3)' }}>
                            {t('semester')}
                            <Typography variant="h5" style={{ color: '#FFF' }} component="div">
                                {
                                    (reseller && totals.resellerPrice && resellerType === 'M') && (totals.subTotals && totals.subTotals.length > index) &&
                                    <div style={{
                                        textAlign: 'center',
                                        fontSize: 16,
                                        textDecoration: 'line-through'
                                    }}>
                                        {(totals.subTotals[index].resellerPrice*6*0.85).toFixed(0)} {currencyMap[quote.currency].symbol}
                                    </div>
                                }
                            {(totals.subTotals && totals.subTotals.length > index) ? totals.subTotals[index].semester.toFixed(0) : 0} {currencyMap[currency].symbol}
                            </Typography>
                        </Grid>
                        <Grid item xs={4} style={{ textAlign: 'center', borderLeft: '1px solid rgba(255,255,255,0.3)' }}>
                            {t('year')}
                            <Typography variant="h5" style={{ color: '#FFF' }} component="div">
                                {
                                    (reseller && totals.resellerPrice && resellerType === 'M') && (totals.subTotals && totals.subTotals.length > index) &&
                                    <div style={{
                                        textAlign: 'center',
                                        fontSize: 16,
                                        textDecoration: 'line-through'
                                    }}>
                                        {(totals.subTotals[index].resellerPrice*12*0.75).toFixed(0)} {currencyMap[quote.currency].symbol}
                                    </div>
                                }
                            {(totals.subTotals && totals.subTotals.length > index) ? totals.subTotals[index].annual.toFixed(0) : 0} {currencyMap[currency].symbol}
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
              }
        </Fragment>
    )
}

  function handleAddSubQuote () {
      if (quote.subQuotes) {
        setQuote({
            ...quote,
            subQuotes: [
                ...quote.subQuotes,
                {
                    id: quote.id,
                    name: '',
                    country: '',
                    luxury: false,
                    roomTypes: 5,
                    extraDiscount: 0,
                    setupDiscount: 0,
                    competitor: 7,
                    seasonal: false,
                    rateChecker: false,
                    restrictions: false,
                    group: false,
                    duration: 12,
                    autopilot: false,
                    displacement: false,
                    gapAnalysis: false,
                    commission: false,
                    rateGrid: false,
                    financial: false,
                    bi: true,
                    rms: true,
                    eye: false,
                    flights: false,
                    consultancy: false,
                    product: '',
                    channels: 1,
                    hotels: 1,
                    frequency: 2,
                    los: 1,
                    daysOut: 120,
                    daysOutW: 365,
                    dailyFrequency: 2,
                    weeklyFrequency: 1,
                    priceConfigCode: quote.priceConfigCode,
                    currency: 'EUR',
                    markup: 0,
                    promo: quote.promo,
                    properties: 1
              }
            ]
        })
      } else {
        setQuote({
            ...quote,
            subQuotes: [
                {
                    id: quote.id,
                    name: '',
                    country: '',
                    luxury: false,
                    roomTypes: 5,
                    extraDiscount: 0,
                    setupDiscount: 0,
                    competitor: 7,
                    seasonal: false,
                    rateChecker: false,
                    restrictions: false,
                    group: false,
                    duration: 12,
                    autopilot: false,
                    displacement: false,
                    gapAnalysis: false,
                    commission: false,
                    rateGrid: false,
                    financial: false,
                    bi: true,
                    rms: true,
                    eye: false,
                    flights: false,
                    consultancy: false,
                    product: '',
                    channels: 1,
                    hotels: 1,
                    frequency: 2,
                    los: 1,
                    daysOut: 120,
                    daysOutW: 365,
                    dailyFrequency: 2,
                    weeklyFrequency: 1,
                    priceConfigCode: quote.priceConfigCode,
                    currency: 'EUR',
                    markup: 0,
                    promo: quote.promo,
                    properties: 1
                }
            ]
        })
      }
  }

    async function getDeals () {
      const headers = new Headers()
      headers.append('Api-Token', '2e7529fec5b6cc682ad9ef87966e9384420a6712cc1a4e5de73d')

      const response = await fetch('https://lybra.api-us1.com/api/3/deals/512', {
          method: 'GET',
          headers
      })
  }

  function isQuoteReadOnly (data) {
      if (!user || !quote) return true
      if (currentUser && user && currentUser !== user.sub) return true
      if(data && data.overrideConfirmed) return true
      if(!data && accepted) return false
      return accepted
  }

  function isQuoteReadOnlyNotBecauseOverride (data) {
      if (!user || !quote) return true
      if (currentUser && user && currentUser !== user.sub) return true
      if(!data && accepted) return false
      return accepted
}

  function getSetupDiscount(data){
    if(data.promo && promos && data.promo !== ''){
        if(promos[data.promo].setupDiscount){
            data.setupDiscount = promos[data.promo].setupDiscount*100
        }else{
            data.setupDiscount = 0
        }
    }
    return data.setupDiscount
  }

  return (
    <div>

      {
        (!isAuthenticated || isLoading) ?
        <div style={{
            position: 'fixed',
            background: '#f0f0f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
        }}>
            <Box style={{
                flexDirection: 'column',
                display: 'flex',
                alignItems: 'center'
            }} sx={{ width: '200px' }}>
                <div style={{
                    width: '100%',
                    marginBottom: '10px',
                    textAlign: 'center'
                }}>
                    <img
                        style={{ display: 'inline-block' }}
                        src="https://lybra.tech/wp-content/uploads/2021/04/logopositivo.png" />
                </div>
                <div style={{ width: '100%'}}>
                    <LinearProgress />
                </div>
            </Box>
        </div>
        :
        <div style={{
            marginBottom: '200px'
        }}>
            {
                quote &&
                <div>
                    <div style={{
                        maxWidth: '900px',
                        margin: '0 auto',
                        marginTop: '1rem'
                    }}>

                        <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
                        <img
                            style={{ display: 'inline-block' }}
                            src="https://lybra.tech/wp-content/uploads/2021/04/logopositivo.png" />
                        </div>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <img 
                                onClick={() => {
                                    i18n.changeLanguage('it')
                                }}
                                style={{ cursor: 'pointer', height: 30 }} src="https://img.icons8.com/color/48/000000/italy.png"/>
                            <img 
                                onClick={() => {
                                    i18n.changeLanguage('en')
                                }}
                                style={{ cursor: 'pointer', height: 30, marginLeft: 10 }} src="https://img.icons8.com/color/48/000000/great-britain.png"/>
                            <img 
                                onClick={() => {
                                    i18n.changeLanguage('es')
                                }}
                                style={{ cursor: 'pointer', height: 30, marginLeft: 10 }} src="https://img.icons8.com/color/48/000000/spain.png"/>
                            <img 
                                onClick={() => {
                                    i18n.changeLanguage('de')
                                }}
                                style={{ cursor: 'pointer', height: 30, marginLeft: 10 }} src="https://img.icons8.com/color/48/000000/germany.png"/>
                        </div>

                        {
                            user &&
                            <div style={{
                                marginTop: '20px',
                                marginBottom: '20px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <img style={{
                                    height: 50,
                                    width: 50,
                                    borderRadius: '100%'
                                }} src={user.picture} />

                                <div style={{ marginTop: '15px' }}>
                                    {user.name}
                                </div>
                                <div style={{ fontSize: '12px', color: '#949494' }}>
                                    {user.email}
                                </div>

                                <Button style={{ marginTop: '5px' }} onClick={() => logout({
                                    returnTo: window.location.origin
                                })}>
                                    Logout
                                </Button>
                            </div>
                        }

                        <div style={{marginBottom: '1rem'}}>
                            
                            <Grid container spacing={4} style={{ marginTop: '0.5rem', alignItems: 'center' }}>
                                <Grid item xs={12} sm={6}>
                                    <Button
                                    onClick={() => {
                                        const id = uuidv4()
                                        setQuote({
                                            id,
                                            name: '',
                                            country: '',
                                            luxury: false,
                                            roomTypes: 5,
                                            extraDiscount: 0,
                                            setupDiscount: 0,
                                            competitor: 7,
                                            seasonal: false,
                                            rateChecker: false,
                                            group: false,
                                            duration: 12,
                                            autopilot: false,
                                            displacement: false,
                                            gapAnalysis: false,
                                            commission: false,
                                            rateGrid: false,
                                            financial: false,
                                            bi: true,
                                            rms: true,
                                            eye: false,
                                            flights: false,
                                            restrictions: false,
                                            consultancy: false,
                                            product: '',
                                            channels: 1,
                                            hotels: 1,
                                            frequency: 2,
                                            los: 1,
                                            daysOut: 120,
                                            daysOutW: 365,
                                            dailyFrequency: 2,
                                            weeklyFrequency: 1,
                                            priceConfigCode: undefined,
                                            currency: 'EUR',
                                            markup: 0
                                        })
                                        setTimestamp(getDateString())
                                        setExpiration(14)
                                        setCurrentDealId(undefined)
                                        localStorage.setItem('lb_last_quote_id_v2', id)
                                    }}
                                    style={{ marginRight: '1rem' }} startIcon={<AddIcon />} variant="contained"
                                    disabled={isQuoteReadOnly(undefined)}>
                                    {t('nuovo')}
                                </Button>

                                <Button 
                                    startIcon={<SearchIcon />}
                                    style={{ marginRight: '1rem' }} 
                                    onClick={() => {
                                        if (currentUser) {
                                            const quoteListRef = ref(database, 'quotes/' + currentUser)
                                            const quoteList = []
                                            onValue(quoteListRef, (snapshot) => {
                                                snapshot.forEach((childSnapshot) => {
                                                    quoteList.push({
                                                        id: childSnapshot.key,
                                                        value: childSnapshot.val()
                                                    })
                                                });
                                                setUserQuoteList(quoteList)
                                            }, {
                                                onlyOnce: true
                                            });
                                            
                                            handleClickOpen()
                                        }
                                    }}>
                                        {t('load')}
                                </Button>

                                    {
                                        (quote.name && quote.product && quote.country && currentUser) &&
                                        <div style={{
                                            display: (!pdfGenerated) ? 'initial' : 'none'
                                        }}>
                                            <Button
                                                startIcon={<ShareIcon />} 
                                                onClick={() => {                                                    
                                                    if (isQuoteReadOnlyNotBecauseOverride(quote) || currentDealId) {
                                                        setShare(true)
                                                        return
                                                    }
                                                    
                                                    if (acOwnerId && !currentDealId) {
                                                        fetchDeals()
                                                    } else {
                                                        handleDealAssign(undefined)
                                                    }
                                                }}>
                                                    Link
                                            </Button>
                                        </div>
                                    }

                                    <Dialog fullWidth={true} maxWidth={'sm'} open={selectDeal} onClose={() => setSelectDeal(false)}>
                                        <DialogTitle>{t('assignDeal')}</DialogTitle>
                                        <DialogContent>
                                        <TextField
                                            style={{ marginTop: '0.3rem' }}
                                            onChange={e => setSearchDeal(e.target.value)}
                                            fullWidth
                                            label={t('search')} />
                                        </DialogContent>
                                        <DialogContent sx={{ padding: 0 }}>
                                            <List sx={{ width: '100%' }}>
                                                {
                                                    Object.keys(deals).filter(key => {
                                                        if (searchDeal && searchDeal !== '') {
                                                            return deals[key].toLowerCase().indexOf(searchDeal.toLowerCase()) > -1
                                                        }
                                                        return key
                                                    }).map((key, index) => (
                                                        <Fragment>
                                                            <ListItem key={index}>
                                                                <ListItemButton onClick={() => {
                                                                    handleDealAssign(key)
                                                                }}>
                                                                    {deals[key]}
                                                                </ListItemButton>
                                                            </ListItem>
                                                            <Divider/>
                                                        </Fragment>
                                                    ))
                                                }
                                            </List>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button color='error' onClick={() => {
                                                setSelectDeal(false)
                                                setShare(false)
                                            }}>Cancel</Button>
                                        </DialogActions>
                                    </Dialog>

                                    <Dialog onClose={() => setShare(false)} open={share}>
                                        <DialogTitle>
                                            Link preventivo
                                            <IconButton
                                                aria-label="close"
                                                onClick={() => setShare(false)}
                                                sx={{
                                                    position: 'absolute',
                                                    right: 8,
                                                    top: 8
                                                }}
                                                >
                                                <CloseIcon />
                                            </IconButton>
                                        </DialogTitle>
                                        <DialogContent>
                                            <div id={'quoteLink'} style={{
                                                backgroundColor: '#ebfeff',
                                                border: '1px solid #63aaad',
                                                padding: '1rem',
                                                borderRadius: '10px',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                window.getSelection().selectAllChildren(
                                                    document.getElementById('quoteLink')
                                                )
                                            }}>
                                                {currentUser ? 'https://pricing.lybra.tech/view/'+currentUser.substring(6)+'/'+quote.id : ''}
                                            </div>

                                            {
                                                (quote.name && quote.product && quote.country && currentUser) &&
                                                <div style={{ marginTop: '1rem' }}>
                                                    <Button
                                                        onClick={() => window.open('https://wa.me/?text=https://pricing.lybra.tech/view/' + currentUser.substring(6) + '/' + quote.id)}>
                                                            Whatsapp
                                                    </Button>
                                                </div>
                                            }
                                        </DialogContent>
                                    </Dialog>

                                    <SimpleDialog
                                        selectedValue={selectedValue}
                                        open={open}
                                        onClose={handleClose}
                                        data={userQuoteList}
                                    />
                                </Grid>

                                <Grid xs={12} sm={3} item>
                                        <Grid container xs={12} sm={12} spacing={0} style={{ alignItems: 'center', justifyItems:'center'}}>
                                            <Grid item xs={12} sm={12} style={{ alignItems: 'center', justifyItems:'center'}}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="currency">{t('currency')}</InputLabel>
                                                    <Select
                                                        labelId="currency"
                                                        id="currency"
                                                        fullWidth
                                                        value={currency}
                                                        label={t('currency')}
                                                        onChange={(event) => {
                                                            setCurrency(event.target.value)
                                                        }}
                                                        disabled={forcedCurrency}
                                                        >
                                                            <MenuItem value='EUR'>€ - Euro</MenuItem>
                                                            <MenuItem value='USD'>$ - US Dollar</MenuItem>    
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>


                                {
                                    (userList && userList.length > 0) &&
                                    <Grid xs={12} sm={3} item>
                                        <Grid container xs={12} sm={12} spacing={1} style={{ alignItems: 'center'}}>
                                            <Grid item xs={12} sm={8}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="user">{t('user')}</InputLabel>
                                                    <Select
                                                        labelId="user"
                                                        id="user"
                                                        fullWidth
                                                        value={currentUser}
                                                        label="Prodotto"
                                                        onChange={(event) => {
                                                            setCurrentUser(event.target.value)
                                                        }}
                                                        >
                                                        {userList && userList.length > 0 && userList.map( us => (
                                                            <MenuItem value={us.id}>{us.value.name}</MenuItem>    
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                            <Button variant={'contained'} onClick={() => {
                                                navigate('/stats')
                                            }}>Stats</Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                        </div>

                        {renderQuote(data => {
                            if (data.product === 'ASSISTANT_LEI') {
                                setQuote({
                                    ...data,
                                    competitor: 7,
                                    roomTypes: 7,
                                    gapAnalysis: true,
                                    commission: true,
                                    channels: 3,
                                    seasonal: false,
                                    group: false
                                })
                            } else if (data.product === 'ASSISTANT_BUS') {
                                setQuote({
                                    ...data,
                                    competitor: 5,
                                    roomTypes: 5,
                                    gapAnalysis: true,
                                    commission: true,
                                    channels: 3,
                                    seasonal: false,
                                    group: false
                                })
                            } else {
                                setQuote(data)
                            }
                        }, quote, 0)}

                        {
                            (quote && quote.subQuotes) &&
                            quote.subQuotes.map((subQuote, index) => renderQuote(data => {
                                setQuote({
                                    ...quote,
                                    subQuotes: quote.subQuotes.map((q, i) => {
                                        if (i !== index) return q
                                        return data
                                    })
                                })
                            }, subQuote, (index+1), true))
                        }

                        {/* <Button
                            variant={'contained'}
                            onClick={() => {
                                handleAddSubQuote()
                            }}
                            size={'large'}
                            fullWidth
                            style={{ marginTop: '1rem' }} startIcon={<AddIcon />}
                            disabled={isQuoteReadOnly(undefined)}>
                            {t('addproperty')}
                        </Button> */}

                    </div>

                    <div style={{
                        position: 'fixed',
                        bottom: 0,
                        width: '100%',
                        background: '#1c90bc',
                        paddingTop: (reseller && resellerType && resellerType === 'M') ? '.5rem':'1rem',
                        paddingBottom: '1rem',
                        height: (reseller && resellerType && resellerType === 'M') ? '60px':'50px',
                        color: '#FFF',
                        zIndex: 1
                    }} hidden={!(quote.name && quote.product && quote.country)}>
                        <Grid container spacing={0}>
                        <Grid item xs={4} style={{ textAlign: 'center' }}>
                            {t('monthly')}
                            <Typography variant="h5" style={{ color: '#FFF' }} component="div">
                                {
                                    (reseller && totals.resellerPrice && resellerType === 'M') &&
                                    <div style={{
                                        textAlign: 'center',
                                        fontSize: 16,
                                        textDecoration: 'line-through'
                                    }}>
                                        {totals.resellerPrice.toFixed(0)} {currencyMap[quote.currency].symbol}
                                    </div>
                                }
                            {totals.month.toFixed(0)} {currencyMap[currency].symbol}
                            </Typography>
                        </Grid>
                        <Grid item xs={4} style={{ textAlign: 'center', borderLeft: '1px solid rgba(255,255,255,0.3)' }}>
                            {t('semester')}
                            <Typography variant="h5" style={{ color: '#FFF' }} component="div">
                                {
                                    (reseller && totals.resellerPrice && resellerType === 'M') &&
                                    <div style={{
                                        textAlign: 'center',
                                        fontSize: 16,
                                        textDecoration: 'line-through'
                                    }}>
                                        {(totals.resellerPrice*6*0.85).toFixed(0)} {currencyMap[quote.currency].symbol}
                                    </div>
                                }
                            {totals.semester.toFixed(0)} {currencyMap[currency].symbol}
                            </Typography>
                        </Grid>
                        <Grid item xs={4} style={{ textAlign: 'center', borderLeft: '1px solid rgba(255,255,255,0.3)' }}>
                            {t('year')}
                            <Typography variant="h5" style={{ color: '#FFF' }} component="div">
                                {
                                    (reseller && totals.resellerPrice && resellerType === 'M') &&
                                    <div style={{
                                        textAlign: 'center',
                                        fontSize: 16,
                                        textDecoration: 'line-through'
                                    }}>
                                        {(totals.resellerPrice*12*0.75).toFixed(0)} {currencyMap[quote.currency].symbol}
                                    </div>
                                }
                            {totals.annual.toFixed(0)} {currencyMap[currency].symbol}
                            </Typography>
                        </Grid>
                        </Grid>
                    </div>
                </div>
            }
        </div>
      }

    </div>
  );
}

export default PriceCalculator;
